import store from 'store'
import uuidv4 from 'uuid/v4'

import constants from 'config/constants'

export const oauthDomain = {
  deleteNonce(nonce) {
    const key = `${constants.oauth.noncePrefix}.${nonce}`
    store.remove(key)
  },
  cleanupNonces(now = Date.now()) {
    deleteExpiredNonces(now)
    deleteInvalidNonces(now)
  },
  /**
   *
   * @param {object} params
   * @param {string} params.redirectPathname
   * @param {string} params.serviceName
   * @param {string} params.workspaceToken
   */
  generateNonce(params, expiryMs = 5 * 60 * 1000) {
    const nonce = uuidv4()

    store.set(
      `${constants.oauth.noncePrefix}.${nonce}`,
      JSON.stringify({
        ...params,
        expiredAt: Date.now() + expiryMs,
      })
    )

    return nonce
  },

  /**
   *
   * @typedef {object} OauthAppState
   * @property {number=} expiredAt time when the nonce will expire in unix number
   * @property {string=} redirectPathname pathname to redirect after succesful authentication
   * @property {string=} serviceName the name of the 3rd party service we want to connect with
   * @property {string=} workspaceToken the token of workspace
   */

  /**
   *
   * @returns {OauthAppState} constants.oauth app state
   */
  getAppState(nonce) {
    try {
      return JSON.parse(getRawAppState(nonce))
    } catch (_) {
      return {}
    }
  },
  isNonceValid(nonce, now = Date.now()) {
    const { expiredAt, redirectPathname } = oauthDomain.getAppState(nonce)
    const expired = now >= expiredAt

    return !expired && redirectPathname
  },
  findValidNonceByServiceName(serviceName, now = Date.now()) {
    let match

    store.each((_, key) => {
      if (!key.startsWith(constants.oauth.noncePrefix)) {
        return
      }

      const nonce = key.substring(constants.oauth.noncePrefix.length + 1)
      const appState = oauthDomain.getAppState(nonce)

      if (appState.serviceName !== serviceName) {
        return
      }

      if (!oauthDomain.isNonceValid(nonce, now)) {
        return
      }

      if (!match || appState.expiredAt > match.appState.expiredAt) {
        match = { nonce, appState }
      }
    })

    return match
  },
}

function deleteExpiredNonces(now) {
  store.each((_, key) => {
    if (key.startsWith(constants.oauth.noncePrefix)) {
      const nonce = key.substring(constants.oauth.noncePrefix.length + 1)
      const { expiredAt } = oauthDomain.getAppState(nonce)
      const expired = now >= expiredAt

      if (expired) {
        store.remove(key)
      }
    }
  })
}

function deleteInvalidNonces(now) {
  store.each((_, key) => {
    if (key.startsWith(constants.oauth.noncePrefix)) {
      const nonce = key.substring(constants.oauth.noncePrefix.length + 1)

      if (!oauthDomain.isNonceValid(nonce, now)) {
        store.remove(key)
      }
    }
  })
}

function getRawAppState(nonce) {
  return store.get(`${constants.oauth.noncePrefix}.${nonce}`)
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/domains/authentication/oauth.js